var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx } from "react/jsx-runtime";
import { useEffect, useRef } from 'react';
import BackgroundImageShapeSection from './Micros/BackgroundImageShapeSection';
import BackgroundDesktop from '../../assets/images/why-envestnet/background-shape/main-background-desktop.svg';
import BackgroundTablet from '../../assets/images/why-envestnet/background-shape/main-background-tablet.svg';
import BackgroundMobile from '../../assets/images/why-envestnet/background-shape/main-background-mobile.svg';
import runAndCreateTimeline from './animations/index';
import './TwoColumnBackgroundShape.scss';
import useViewport from '../../hooks/useViewport';
var mainBackgroundImage = {
    desktop: BackgroundDesktop,
    tablet: BackgroundTablet,
    mobile: BackgroundMobile,
};
var TwoColumnBackgroundShape = function (_a) {
    var data = _a.data;
    var imageAssets = data.mediaAssets, mainTitle = data.mainTitle, mainParagraph = data.mainParagraph;
    var visualViewport = useViewport().visualViewport;
    var isMobile = visualViewport.width < 768;
    var isTablet = visualViewport.width < 1024 && visualViewport.width >= 768;
    var isDesktop = visualViewport.width >= 1024;
    var withAnimation = true;
    if (data.withAnimation !== undefined) {
        withAnimation = data.withAnimation;
    }
    var firstLeafRowRef = useRef(null);
    var mainElementTriggerRef = useRef(null);
    var secondLeafRowRef = useRef(null);
    useEffect(function () {
        if (withAnimation) {
            runAndCreateTimeline({
                firstLeafRowRef: firstLeafRowRef,
                secondLeafRowRef: secondLeafRowRef,
                mainElementTriggerRef: mainElementTriggerRef,
            });
        }
    }, []);
    return (_jsx("div", __assign({ ref: mainElementTriggerRef, className: "two-column-background-shape relative w-full snap-start bg-no-repeat lg:px-10 my-10 overflow-visible", style: {
            backgroundImage: "url(" + mainBackgroundImage.desktop + ")",
            paddingBottom: "" + (isDesktop ? "128px" : isTablet ? "80px" : isMobile ? "64px" : ''),
            marginBottom: '0px',
            marginTop: '0px',
        } }, { children: _jsx(BackgroundImageShapeSection, __assign({ firstLeafRowRef: firstLeafRowRef, secondLeafRowRef: secondLeafRowRef, imageAssets: imageAssets }, { mainTitle: mainTitle, mainParagraph: mainParagraph }), void 0) }), void 0));
};
export default TwoColumnBackgroundShape;
